import post_weight from "./postWeight";
import get_all_weights_reducer from "./getAllWeights";
import get_all_smoking_logs_reducer from "./getAllSmokingLogs";
import load_personalised_content from "./getPersonalisedContent";
import load_content from "./getContent";
import get_programme_step_reducer from "./getProgrammeStep";
import update_current_view_data_reducer from "./updateCurrentViewData";
import post_complete_question_reducer from "./postCompleteQuestion";
import signup_flow_data_reducer from "./signupFlowData";
import load_profile_reducer from "./getProfile";
import get_programme_overview_reducer from "./getProgrammeOverview";
import { programmeApi } from "../../redux/programmeApi";
import { programmeApiV2 } from "../../redux/programmeApiV2";
import { programmeStepApi } from "../../redux/programmeStepApi";

import { profileApi } from "../../redux/profileApi";
import { profileApiV2 } from "../../redux/profileApiV2";
import { profileApiV3 } from "../../redux/profileApiV3";
import { referralApi } from "../../redux/referralApi";
import { referralApiV5 } from "../../redux/referralApiV5";
import { engagementsApi } from "../../redux/engagementsApi";
import profileBuilderReducer from "../../redux/slices/profileBuilderSlice";
import progressBarReducer from "../../redux/slices/progressBarSlice";
import otpReducer from "../../redux/slices/otpSlice";

import { configureStore } from "@reduxjs/toolkit";
import { rtkQueryErrorLogger } from "../../redux/middleware/errorLoggingMiddleware";

export const store = configureStore({
  reducer: {
    signupFlowData: signup_flow_data_reducer,
    profile: load_profile_reducer,
    personalisedContent: load_personalised_content,
    content: load_content,
    allWeights: get_all_weights_reducer,
    allSmokingLogs: get_all_smoking_logs_reducer,
    weightLogging: post_weight,
    programmeStep: get_programme_step_reducer,
    programmeOverview: get_programme_overview_reducer,
    currentViewData: update_current_view_data_reducer,
    completeQuestion: post_complete_question_reducer,
    [profileApi.reducerPath]: profileApi.reducer,
    [profileApiV2.reducerPath]: profileApiV2.reducer,
    [profileApiV3.reducerPath]: profileApiV3.reducer,
    [referralApi.reducerPath]: referralApi.reducer,
    [referralApiV5.reducerPath]: referralApiV5.reducer,
    [programmeApi.reducerPath]: programmeApi.reducer,
    [programmeApiV2.reducerPath]: programmeApiV2.reducer,
    [engagementsApi.reducerPath]: engagementsApi.reducer,
    [programmeStepApi.reducerPath]: programmeStepApi.reducer,
    otp: otpReducer,
    profileBuilder: profileBuilderReducer,
    progressBar: progressBarReducer,
  },
  // Adding the api middleware enables caching, invalidation, polling,
  // and other useful features of `rtk-query`.
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware()
      .concat(programmeApi.middleware)
      .concat(programmeApiV2.middleware)
      .concat(programmeStepApi.middleware)
      .concat(referralApi.middleware)
      .concat(referralApiV5.middleware)
      .concat(engagementsApi.middleware)
      .concat(profileApi.middleware)
      .concat(profileApiV2.middleware)
      .concat(profileApiV3.middleware)
      .concat(rtkQueryErrorLogger),
});
